import { Box, Icon, Text } from '@factorialco/deprecated-design-system'
import {
  BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum,
  PayrollDetailsIncidenceViewFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import MissingField from './MissingField'

interface Props {
  ruleEvaluation: PayrollDetailsIncidenceViewFragment
  employeeId: string
}

const DetailedView = ({ ruleEvaluation, employeeId }: Props) => {
  const contractVersionId = ruleEvaluation.incidence?.targetId

  return (
    <>
      {ruleEvaluation.validity !== 'valid' && (
        <Box gap="s24">
          <Box gap="s8">
            <Icon.Large icon="alert" color="champagne1000" />
            <Text.Normal size="200" weight="semibold" color="grey1000">
              {ruleEvaluation.validity === 'blocked'
                ? i18n.t('bookkeepers.incidence.incidence_rules.admin.header.blockage')
                : i18n.t('bookkeepers.incidence.incidence_rules.admin.header.recommendation')}
            </Text.Normal>
            <Text.Normal size="200" color="grey1000">
              {ruleEvaluation.validity === 'blocked'
                ? i18n.t('bookkeepers.incidence.incidence_rules.admin.description.blockage')
                : i18n.t('bookkeepers.incidence.incidence_rules.admin.description.recommendation')}
            </Text.Normal>
            <ul style={{ listStyle: 'disc' }}>
              <Box gap="s4" paddingX="s16">
                {ruleEvaluation.missingFields.map(
                  (missingField: {
                    field: string
                    severity: BookkeepersManagementValueObjectsIncidenceRuleEnforcementEnum
                  }) => (
                    <MissingField
                      key={missingField.field}
                      missingField={missingField}
                      employeeId={employeeId}
                      contractVersionId={contractVersionId}
                    />
                  )
                )}
              </Box>
            </ul>
          </Box>
        </Box>
      )}
    </>
  )
}

export default DetailedView
